// extracted by mini-css-extract-plugin
export default {"icons":"MenuHamburguerContente_icons__4rQVd","link":"MenuHamburguerContente_link__qZ1gt","content":"MenuHamburguerContente_content__vz3+V"};